import { ReactElement } from "react";
import toast, { Toast } from "react-hot-toast";
import { CheckCircle2, AlertCircle, Info, XCircle, X } from "lucide-react";

type PopUpProps = {
  t: Toast;
  message: string;
  type?: "success" | "error" | "warning" | "info";
};

export const PopUp = ({
  t,
  message,
  type = "info",
}: PopUpProps): ReactElement => {
  const styles = {
    success: {
      border: "border-[1.5px] border-[#8ba499]",
      bg: "bg-[#effdf4]",
      wrapper: "bg-green-50",
      text: "text-green-700",
      icon: <CheckCircle2 className="w-5 h-5 text-[#5b836d]" />,
    },
    error: {
      border: "border-[1.5px] border-[#d68a92]",
      bg: "bg-[#fdf5f6]",
      wrapper: "bg-[#fdf5f6]",
      text: "text-red-700",
      icon: <XCircle className="w-5 h-5 text-[#e16063]" />,
    },
    warning: {
      border: "border-l-4 border-yellow-500",
      bg: "bg-white",
      wrapper: "bg-yellow-50",
      text: "text-yellow-700",
      icon: <AlertCircle className="w-5 h-5 text-yellow-500" />,
    },
    info: {
      border: "border-l-4 border-blue-500",
      bg: "bg-white",
      wrapper: "bg-blue-50",
      text: "text-blue-700",
      icon: <Info className="w-5 h-5 text-blue-500" />,
    },
  };

  const currentStyle = styles[type];

  return (
    <div
      className={`${
        t.visible ? "animate-enter" : "animate-leave"
      } w-auto max-w-md pointer-events-auto`}
    >
      <div
        className={`${currentStyle.wrapper} ${currentStyle.border} rounded shadow-lg`}
      >
        <div className={`${currentStyle.bg} rounded flex items-center p-1`}>
          <div className="flex flex-1 items-start p-3 space-x-3 min-w-0">
            <div className="flex-shrink-0">{currentStyle.icon}</div>
            <div className={`flex-1 min-w-0 ${currentStyle.text}`}>
              <p className="text-sm font-medium" title={message}>
                {message}
              </p>
            </div>
          </div>
          <div className="flex flex-shrink-0 pr-2">
            <button
              onClick={() => toast.dismiss(t.id)}
              className={`p-2 rounded-full hover:bg-black/5 focus:outline-none ${currentStyle.text}`}
            >
              <X className="w-5 h-5 text-[#9f9d9b] font-bold" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
